import { useContext, useState, useEffect, FC } from "react";
import { Container, CardButton } from "./FeaturedManagersStyle";
import { ThemeContext } from "@fluentui/react-theme-provider";
import { translate } from "../../utils/i18n";
import {publicUrl} from '../../config';

interface IManagersMap
{
    [key: string]: string[];
}

interface IFeaturedManagersProps
{
    selectedManagers: string[];
    onClick: (managers: string[]) => void;
    readOnly?: boolean;
}

const MANAGERS: IManagersMap =
{
    "m&g":
    [
        "M&G LUXEMBOURG S.A",
        "M&G LUXEMBOURG S.A.",
        "M&G SECURITIES LIMITED*"
    ],
    fidelity:
    [
        "FIDELITY INTERNATIONAL",
        "FIDELITY UCITS II ICAV"
    ],
    vontobel:
    [
        "VONTOBEL AM",
        "VONTOBEL FUND II"
    ],
    gam:
    [
        "GAM STERLING MANAGEMENT LIMITED",
        "GAM (LUXEMBOURG) S.A."
    ],
    janusHenderson:
    [
        'JANUS HENDERSON CAPITAL',
        'JANUS HENDERSON INVESTORS',
        'JANUS HENDERSON FUND',
        'JANUS HENDERSON HORIZON',
        'HENDERSON GARTMORE SICAV',
        'HENDERSON GLOBAL INVESTORS',
        'HENDERSON INVESTMENT FUNDS LIMITED (GBP)',
        'HENDERSON INVESTMENT FUNDS LIMITED (EUR)',
        'HENDERSON INVESTMENT FUNDS LIMITED (USD)'
    ],
    allianz:
    [
        "ALLIANZ GLOBAL INVESTORS"
    ],
    candriam:
    [
        "CANDRIAM LUX",
        "CANDRIAM (AI)",
        "CANDRIAM FRANCE",
        "CANDRIAM LUX (CACEIS)"
    ],
    jupiter:
    [
        "JUPITER GLOBAL FUND"
    ],
    axa:
    [
        "AXA IM FIIS",
        "AXA INVESTMENT MANAGERS",
        "AXA INVESTMENT MANAGERS PARIS",
        "AXA IM WORLD ACCESS VEHICLE ICAV",
        "AXA ROSENBERG INVESTMENT MANAGEMENT LTD"
    ],
    columbia_threadneedle:
    [
      'COLUMBIA THREADNEEDLE INV SERVICES LTD',
      'COLUMBIA THREADNEEDLE MGMT LUXEMBOURG',
      'COLUMBIA THREADNEEDLE INV SERVICES LTD*'
    ],
    alliance_bernstein:
    [
      'ALLIANCE BERNSTEIN',
      'ALLIANCE BERNSTEIN (BLOCKCHAIN)'
    ]
};

const FeaturedManagers: FC<IFeaturedManagersProps> = ({selectedManagers, onClick, readOnly}) =>
{
    const theme = useContext(ThemeContext);
    const [selection, setSelection] = useState<string[]>([]);

    useEffect(() => 
    {
        if(selectedManagers !== undefined)
        {
            var selection = Object.keys(MANAGERS).filter((manager) => 
            {
                const translatedManager = translate(MANAGERS[manager][0]);
                const selected = selectedManagers.some((name) => translate(name) === translatedManager);
                return selected;
            }).map((manager) => translate(MANAGERS[manager][0]));

            setSelection(selection);
        }
    }, [selectedManagers]);

    return(
        <Container>
            {Object.keys(MANAGERS).map((manager, manageIndex) =>
            {
                return(
                    <CardButton theme={theme}
                        selected={selection.some((name) => name === translate(MANAGERS[manager][0]))}
                        anyselected={selection.length}
                        key={'manageIndex' + manageIndex}
                        readOnly={readOnly}
                    >
                        <picture onClick={() => onClick(MANAGERS[manager])}>
                            <source srcSet={`${publicUrl}/images/${manager}.avif`} type="image/avif" />
                            <source srcSet={`${publicUrl}/images/${manager}.webp`} type="image/webp" />
                            <img src={`${publicUrl}/images/${manager}.jpg`} alt="Añadir/eliminar del filtro de gestoras" />
                        </picture>
                    </CardButton>
                );
            })}
        </Container>
    );
};

export default FeaturedManagers; 